/* istanbul ignore file */
export * from './date-with-ordinal.pipe';
export * from './interpolate.pipe';
